
import { Vue, Component } from "vue-property-decorator";
import OxygenControl from "@/oxygen/classes/OxygenControl.vue";
import { ControlRepeater } from "@/oxygen/classes/lib/types";
import lodash from "lodash";
import { documentStore, uiStore } from "@/store/store";

type AttributeRow = {
  name: string;
  value: string;
};

@Component({
  components: { OxygenControl }
})
export default class OxygenHtmlAttributes extends Vue {
  get control(): ControlRepeater {
    return {
      type: "repeater",
      name: "HTML Attributes",
      slug: "html_attributes",
      noDataMessage: "None",
      noDisable: true,
      noDuplicate: true,
      titleTemplate: (row: Partial<AttributeRow | undefined>) => {
        return `${row?.name || ""}="${row?.value || ""}"`;
      },
      defaultTitle: "Attribute",
      controls: [
        {
          slug: "name",
          name: "Attribute",
          type: "text",
          disableVariable: true
        },
        {
          slug: "value",
          name: "Value",
          type: "text",
          disableVariable: true
        }
      ]
    };
  }

  get value() {
    return lodash.get(
      uiStore.activeElement,
      `data.properties.settings.advanced.attributes`
    );
  }

  setValue(attrs: Partial<AttributeRow>[]) {
    if (!uiStore.activeElementId) return;

    documentStore.unthrottledPropertyChanged({
      elementId: uiStore.activeElementId,
      path: "settings.advanced.attributes",
      value: attrs,
      meta: {
        snapshotLabel: `Set html attributes for element #${uiStore.activeElementId}`
      }
    });
  }
}
